'use client';

import React from 'react';
import Box, { BoxProps } from '../ui/Box';
import { Entry } from '@/lib/parsers/entries';
import CardGrid from '../CardGrid';
import { JobPositionCard } from '../EntryCard/EntryCard.JobPosition';
import Txt from '../ui/Txt';
import { useTranslations } from 'next-intl';
import NoPositionsCard from './NoPositionsCard';

export type JobPositions = BoxProps<
  'div',
  {
    items?: Entry<'jobPosition'>[];
  }
>;

export default function JobPositions({ items, ...props }: JobPositions) {
  const t = useTranslations('jobPositions');

  return (
    items && (
      <Box {...props}>
        <Txt variant="h4" as="h4" medium cx={{ mB: 'xl' }}>
          {t('available')}
        </Txt>
        {!!items.length ? (
          <CardGrid items={items} Component={JobPositionCard} />
        ) : (
          <NoPositionsCard />
        )}
      </Box>
    )
  );
}
